export default {"src":"/assets/_next/static/media/img-highlight-premium.5b7837f1.svg","height":231,"width":602,"blurWidth":0,"blurHeight":0};